import { render, staticRenderFns } from "./archive-rule-dialog.vue?vue&type=template&id=2b43d632&scoped=true"
import script from "./archive-rule-dialog.vue?vue&type=script&lang=js"
export * from "./archive-rule-dialog.vue?vue&type=script&lang=js"
import style0 from "./archive-rule-dialog.vue?vue&type=style&index=0&id=2b43d632&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b43d632",
  null
  
)

export default component.exports